import React, { useContext } from 'react'
import { Heading, Grid, GridItem, Link, Stack } from '@chakra-ui/react'
import { TiLocationArrowOutline, TiShoppingCart } from 'react-icons/ti'
import {
  clickPromotionDataLayer,
  clickViewRewards,
  viewLocationDataLayer
} from '../../../utils/gtmDatalayer'
import { useNavigate } from 'react-router-dom'
import { AiOutlineTags } from 'react-icons/ai'
import { MainContext } from '../../../context'


const FooterCard = ({
  item,
  accentColor,
  fontFamily,
  dictionary,
  setOverlay,
  skin,
  isBusiness,
  businessData,
  setModalType
}) => {
  const navigate = useNavigate()
  const { setScrollY } = useContext(MainContext)
  const renderCalculateDistance = (val) => {
    if (
      item?.business_type.type === 'physicalVenue' ||
      item?.business_type === 'physicalVenue' ||
      item?.business_type === '' ||
      item?.business_type.type === ''
    ) {
      const isArray = Array.isArray(val.venues)
      const distance =
        isArray === true
          ? val?.venues[0]?.address?.location?.distance
          : val?.venue?.address?.location?.distance
      const km = distance / 1000
      return distance === undefined
        ? dictionary.CARDS.location
        : km.toFixed(1) + ' km'
    }
  }

  const renderOfferSpecificRules = () => {
    return (
      <Heading
        m='0'
        pl='.3rem'
        color={skin === 'COPPEL' ? 'brand.secondaryLight' : accentColor}
        cursor='pointer'
        textDecoration={skin === 'COPPEL' ? 'none' : 'underline'}
        fontSize={['sm', 'sm', 'sm', 'sm']}
        onClick={() => {
          setOverlay(item.socialMedia, item.business_type?.url, true)
          clickPromotionDataLayer(item, dictionary, skin)
          setModalType('TyC')
        }}
        fontFamily={fontFamily}
        fontWeight='500'
        flexDirection='row'
        _hover={{
          color: skin === 'ALBO' ? '#F8644F': null,
          fontWeight:'600'
        }}
      >
        {dictionary.CARDS.more}
      </Heading>
    )
  }

  const renderLocation = () => {
    return (
      <Link
        href={`https://www.google.com/maps/search/?api=1&query=${item?.dv_latlng[1]},${item?.dv_latlng[0]}`}
        target='_blank'
        display='flex'
        alignItems='center'
        justifyContent='flex-start'
        flexDirection='row'
        onClick={() => {
          viewLocationDataLayer(
            item.business_type
              ? renderCalculateDistance(item)
              : dictionary.CARDS.location,
            item,
            dictionary,
            skin
          )
        }}
      >
        {item?.business_type?.type === 'physicalVenue' ||
        item?.business_type?.type === undefined ||
        item?.business_type?.type === '' ||
        item?.business_type === '' ? (
          <TiLocationArrowOutline
            color={skin === 'COPPEL' ? '#F7DD57' : skin === 'FINSUS' ? '#23223F' : accentColor}
            fontSize='1.2rem'
          />
        ) : null}
        <Heading
          color={skin === 'COPPEL' ? 'brand.secondaryLight' : accentColor}
          cursor='pointer'
          textDecoration={skin === 'COPPEL' ? 'none' : 'underline'}
          m='0'
          fontSize={['sm', 'sm', 'sm', 'sm']}
          mt='.2rem'
          fontFamily={fontFamily}
          fontWeight='500'
        >
          {item?.business_type
            ? renderCalculateDistance(item)
            : dictionary.CARDS.location}
        </Heading>
      </Link>
    )
  }

  const goToVenuesLink = () => {
    const set = new Set()
    businessData.map((offer) => {
      set.add(offer.venue._id)
    })
    return (
      <Link
        onClick={() => {
          navigate('/rewards', {
            state: {
              businessData
            }
          })
          clickViewRewards(item, dictionary, skin)
          // Obtener la posición vertical actual de la página
          const currentPosition = window.scrollY
          setScrollY(currentPosition)
        }}
      >
        <Heading
          color={skin === 'COPPEL' ? 'brand.secondaryLight' :  accentColor}
          cursor='pointer'
          textDecoration={skin === 'COPPEL' ? 'none' : 'underline'}
          m='0'
          fontSize={['sm', 'sm', 'sm', 'sm']}
          mt='.2rem'
          fontFamily={fontFamily}
          fontWeight='600'
          display='flex'
          alignItems='center'
          gridColumnGap='2px'
          _hover={{
            color: skin === 'ALBO' ? '#F8644F': null
          }}
        >
          
          <AiOutlineTags
            color={skin === 'COPPEL' ? 'brand.secondaryLight' : skin === 'FINSUS' ? '#23223F' : skin === 'ALBO' ? '#F8644F' : accentColor}
            fontSize='1.2rem'
          />{' '}
          {set.size === 1 ? `${set.size} Sucursal` : `${set.size} Sucursales`}
        </Heading>
      </Link>
    )
  }

  const handleModalType = (bussinessName) => {
    if (skin === 'CLARA') {
      switch (bussinessName) {
        case 'Uber Eats':
          return 'redirectWithCoupon'
        default:
          return 'confirmationRedirect'
      }
    } else {
      return 'confirmationRedirect'
    }
  }

  const renderLink = () => {
    return (
      <Heading
        m='0'
        pl='.3rem'
        color={skin === 'COPPEL' ? 'brand.secondaryLight' : accentColor}
        cursor='pointer'
        textDecoration={skin === 'COPPEL' ? 'none' : 'underline'}
        fontSize={['sm', 'sm', 'sm', 'sm']}
        onClick={() => {
          setOverlay(item.socialMedia, item.business_type?.url, true)
          viewLocationDataLayer(
            dictionary.CARDS.ecommerce,
            item,
            dictionary,
            skin
          )
          setModalType(handleModalType(item?.name))
        }}
        fontFamily={fontFamily}
        fontWeight='600'
        flexDirection='row'
        _hover={{
          color: skin === 'ALBO' ? '#F8644F': null
        }}
      >
        <Stack direction='row'>
          <TiShoppingCart
            color={skin === 'COPPEL' ? '#F7DD57' : skin === 'FINSUS' ? '#23223F' : skin === 'ALBO' ? '#F8644F': accentColor}
            fontSize='1.2rem'
          />
          <div> {dictionary.CARDS.ecommerce}</div>
        </Stack>
      </Heading>
    )
  }

  return (
    <Grid w='100%' templateColumns='repeat(12, 2fr)' pt='.8rem'>
      <GridItem
        colSpan={[6, 6, 6, 6]}
        display='flex'
        alignItems='center'
        justifyContent='flex-start'
        flexDirection='row'
      >
        {isBusiness
          ? goToVenuesLink()
          : item?.business_type?.type === 'ecommerce'
          ? renderLink()
          : renderLocation()}
      </GridItem>
      {!isBusiness && (
        <GridItem
          colSpan={[6, 6, 6, 6]}
          display='flex'
          alignItems='center'
          justifyContent='flex-end'
        >
          {renderOfferSpecificRules()}
        </GridItem>
      )}
    </Grid>
  )
}

export default FooterCard
